import qs from 'qs';
import { Country, Language } from '../../../../../../__generated__/loma';

export const getClaimsPortalLink = (
  claimsPortal: string,
  retailerMoniker: string,
  orderNumber: string | undefined,
  localeLanguage: Language | undefined,
  localeCountry: Country | undefined,
) => {
  let locale: string | undefined;
  if (localeLanguage) {
    if (localeCountry) {
      locale = `${localeLanguage}_${localeCountry}`;
    } else {
      locale = localeLanguage;
    }
  }

  const queryParams = qs.stringify({
    order_number: orderNumber,
    source: 'TRACK_PAGE',
    locale,
  });

  return `${claimsPortal}/${retailerMoniker}/assist?${queryParams}`;
};
